import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import sectionStyles from "../styles/Section.module.css";
import styles from "../styles/MiddleContent.module.css";
import paintWeb from "../imgs/paintWeb.png";
import webDesign from "../imgs/webDesign.png";
import useScrollReveal from "../hooks/useScrollReveal";

export default function MiddleContent() {
  const [headerRef, headerVisible] = useScrollReveal();
  const [firstRef, firstVisible] = useScrollReveal();
  const [secondRef, secondVisible] = useScrollReveal();

  return (
    <div className={styles.middleContainer}>
      <Container>
        <div
          ref={headerRef}
          className={`${sectionStyles.header} ${headerVisible ? sectionStyles.visible : ""}`}
        >
          <p className={`${sectionStyles.eyebrow} ${sectionStyles.eyebrowDark}`}>WHO WE ARE</p>
          <h2 className={`${sectionStyles.heading} ${sectionStyles.headingDark}`}>WELCOME!</h2>
          <p className={`${sectionStyles.subheading} ${sectionStyles.subheadingDark}`}>
            We're a small studio that builds business websites people actually
            enjoy using &mdash; designed around your goals, not a template.
          </p>
        </div>

        <Row
          ref={firstRef}
          className={`${styles.cardRow} ${sectionStyles.card} ${sectionStyles.cardHover} ${firstVisible ? styles.visible : ""}`}
        >
          <Col sm={6} className={styles.textCol}>
            <h3 className={styles.cardTitle}>A website that works as hard as you do</h3>
            <p className={styles.cardContent}>
              Looking to grow your business online? A website is often the
              first impression a customer gets &mdash; we make sure it's a
              great one. From small retail brands to trading companies, we
              build sites that look sharp and load fast on any device.
            </p>
          </Col>
          <Col sm={6}>
            <img src={paintWeb} alt="Designing a website" className={styles.cardImage}/>
          </Col>
        </Row>

        <Row
          ref={secondRef}
          className={`${styles.cardRow} ${sectionStyles.card} ${sectionStyles.cardHover} ${styles.reverseRow} ${secondVisible ? styles.visible : ""}`}
        >
          <Col sm={6} className={styles.imageColMobileFirst}>
            <img src={webDesign} alt="Web design process" className={styles.cardImage}/>
          </Col>
          <Col sm={6} className={styles.textCol}>
            <h3 className={styles.cardTitle}>Built to keep working after launch</h3>
            <p className={styles.cardContent}>
              At Neko, we design and develop websites tailored to your
              business goals. Every build includes Search Engine
              Optimization (SEO), analytics integration, and ongoing support,
              so your site keeps working for you long after launch.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
